module.exports = __webpack_public_path__ + "static/media/NUWalletRounded.9aa6f680.png";